import * as React from "react";
import { useHistory } from "react-router-dom";
import { login } from "../../api/auth";
import styled from "styled-components";
import { select } from "@hubper/theme";

import { TextInput, Button, Text } from "@hubper/core-ui/elements";

import { useUser } from "../../UserProvider";

const Base = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${select.color(["primary", 5])};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  width: 350px;
  background-color: white;
  border-radius: 4px;
  padding: 48px;
`;

type State = {
  email: string;
  password: string;
  error: string | null;
};

function Login() {
  const history = useHistory();

  const { setUser } = useUser();

  const [state, setState] = React.useState<State>({
    email: "",
    password: "",
    error: null
  });

  return (
    <Base>
      <Box>
        <h1 style={{ textAlign: "center" }}>Login</h1>
        <form
          style={{ marginTop: 48 }}
          onSubmit={async evt => {
            evt.preventDefault();
            try {
              const { error, ...credentials } = state;
              const user = await login(credentials);
              setUser(user);

              history.push("/");
            } catch (e) {
              setState(s => ({ ...s, error: "Wrong credentials!" }));
              console.error(e);
            }
          }}
        >
          <TextInput
            label="E-mail"
            value={state.email}
            onChange={(evt: any) =>
              setState({ ...state, email: evt.target.value, error: null })
            }
            style={{ marginBottom: 24 }}
          />
          <TextInput
            type="password"
            label="Password"
            value={state.password}
            onChange={(evt: any) =>
              setState({ ...state, password: evt.target.value, error: null })
            }
            style={{ marginBottom: 32 }}
          />
          <Button stretch type="color" text="Log in" />

          {state.error && (
            <Text c={["error", 5]} fs={-1} style={{ marginTop: 24 }}>
              {state.error}
            </Text>
          )}
        </form>
      </Box>
    </Base>
  );
}

export default Login;
